import { render, staticRenderFns } from "./TheVideocallButton.vue?vue&type=template&id=7bde9647&scoped=true"
import script from "./TheVideocallButton.vue?vue&type=script&lang=js"
export * from "./TheVideocallButton.vue?vue&type=script&lang=js"
import style0 from "./TheVideocallButton.vue?vue&type=style&index=0&id=7bde9647&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bde9647",
  null
  
)

export default component.exports